var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PressHubModule',{attrs:{"module-data":_vm.document,"articles":_vm.articles,"data-luko-tracking":"Page-Press"}})}
var staticRenderFns = []

export { render, staticRenderFns }